export default __webpack_public_path__ + "images/80b91578feb634ef3b36db6e9cb03490-christianity_small.webp";